import type { TestSapConnectionParams, UpsertSapConnectionParams } from '@/domain/models/sap-connection.js';
import type { GetSapConnection, TestSapConnection, UpsertSapConnection } from '@/domain/use-cases/sap-connection.js';
import { BaseControllerImpl } from '@/presentation/controllers/base/implementation.js';

export class SapConnectionController extends BaseControllerImpl {
    constructor(
        private readonly getUseCase: GetSapConnection,
        private readonly upsertUseCase: UpsertSapConnection,
        private readonly testUseCase: TestSapConnection
    ) {
        super();
    }

    public async get(clientId: string) {
        return this.getUseCase.execute(clientId);
    }

    public async upsert(clientId: string, params: UpsertSapConnectionParams) {
        return this.upsertUseCase.execute(clientId, params);
    }

    public async test(clientId: string, params: TestSapConnectionParams) {
        return this.testUseCase.execute(clientId, params);
    }
}
